import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/client/API',
    name: 'Client_API',
    component: () =>
      import(
        /* webpackChunkName: "Client_API" */ '../components/Client/Client_API.vue'
      ),
  },
  {
    path: '/merchant/API',
    name: 'Merchant_API',
    component: () =>
      import(
        /* webpackChunkName: "Merchant_API" */ '../components/Merchant/Merchant_API.vue'
      ),
  },
  {
    path: '/client/SDK',
    name: 'Client_SDK',
    component: () =>
      import(
        /* webpackChunkName: "Client_SDK" */ '../components/Client/Client_SDK.vue'
      ),
  },
  {
    path: '/client/confirm-api',
    name: 'Confirm_API',
    component: () =>
      import(
        /* webpackChunkName: "Confirm_API" */ '../components/Client/Confirm_API.vue'
      ),
  },
  {
    path: '/merchant/SFTP',
    name: 'Merchant_SFTP',
    component: () =>
      import(
        /* webpackChunkName: "Merchant_SFTP" */ '../components/Merchant/Merchant_SFTP.vue'
      ),
  },
  {
    path: '/existing-integrations',
    name: 'Existing_Integrations',
    component: () =>
      import(
        /* webpackChunkName: "Existing_Integrations" */ '../components/ExistingIntegrations/index.vue'
      ),
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
